export default __webpack_public_path__ + "static/media/socialProof.298edfa0.jpg";